import { Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { ProductDetailService } from '../../../shared/services/product-detail.service';
import { AnalyticsService } from '../../services/analytics.service';
import { UtilsService } from '../../services/utils.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-share-widget-modal',
  templateUrl: './notify-me.component.html',
  standalone: true,
  imports: [CommonModule,FormsModule,MatSnackBarModule],
  styleUrls: ['./notify-me.component.scss']
})
export class NotifyMeModalComponent implements OnDestroy {
  environment: any = environment;
  emailId: any;
  pinCode: any;
  sub:Subscription=new Subscription()
  isNotified: boolean = false
  constructor(
    public dialogRef: MatDialogRef<NotifyMeModalComponent>,
    public service: ProductDetailService,
    @Inject(PLATFORM_ID) private platformId:Object,
    public utils: UtilsService,
    public analyticsService:AnalyticsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close()
  }

  onSubmit() {
    this.utils.showLoading()
    let body = {
      productName: this.data.productGuidId,
      pinCode: this.utils.getUserPicode() ? this.utils.getUserPicode() : '',
      userGuidId: this.data.userGuidId ? this.data.userGuidId : null,
      emailId: this.emailId
    }
    this.sub.add(   this.service.notifyProductAvailability(body).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.isNotified = true
          this.triggerNotifyMeEvent()
          this.utils.hideLoading()
        }
        else {
          if (response.statusCode == "NP101"){
            this.triggerNotifyMeEvent()
            this.isNotified = true
          }
          else
            this.utils.openSnackBar(response.message, 'error-toster')
          this.utils.hideLoading()
        }
      }
    }))
  }

  triggerNotifyMeEvent()
  {
    if (isPlatformBrowser(this.platformId)) {

    // if (!this.utils.getToken()){
    //   (<any>window).webengage.user.setAttribute('we_email', this.emailId);
    //   (<any>window).webengage.user.login(this.emailId);
    //   }
    }
    const productInfo = JSON.parse(this.utils.getProductInfo());
    const gtmData = {
      eventName: "Notify Me",
      eventData: {
        'email id':this.emailId,
        'Pin Code': Number(this.utils.getUserPicode()),
        'Product Name': this.data.cart.productName,
        'In Stock': this.data.cart.productInventoryCount > 0 ? true : false,
        'Category Name': productInfo?.category || 'NA',
        'Sub-category name': productInfo.brandSubCategoriesMenus.subCategory,
        'Series Name': productInfo.seriesName,
        'Product Images': this.data.productResponse.landingPageImages,
        'Product price': this.data.cart.productMRP,
      }
    };
    this.analyticsService.trackData(gtmData);
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
